import { render, staticRenderFns } from "./hollowPie.vue?vue&type=template&id=68d326d4"
import script from "./hollowPie.vue?vue&type=script&lang=js"
export * from "./hollowPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d326d4')) {
      api.createRecord('68d326d4', component.options)
    } else {
      api.reload('68d326d4', component.options)
    }
    module.hot.accept("./hollowPie.vue?vue&type=template&id=68d326d4", function () {
      api.rerender('68d326d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/echarts/pie/components/hollowPie.vue"
export default component.exports